export const cardBadgeStyles = {
  alignItems: 'center',
  borderRadius: 0.5,
  display: 'flex',
  font: '700 13px/13px Gothic A1',
  height: 20,
  justifyContent: 'center',
  marginTop: 3,
  width: 32,
};

export const cardButtonSelectStyles = {
  gridColumn: '1 / 3',
  height: 64,
};

export const cardHeaderStyles = {
  display: 'grid',
  gridColumn: '1 / 3',
  gridTemplateColumns: '1fr 32px 28px',
  width: '100%',
};

export const cardMenuStyles = theme => ({
  gridColumn: 3,
  paddingLeft: theme.spacing(0.5),
});

export const ellipsesStyles = theme => ({
  '&:hover': {
    backgroundColor: theme.palette.secondary.light,
  },
  backgroundColor: theme.palette.white,
  borderRadius: '100%',
  color: theme.palette.secondary.main,
  cursor: 'pointer',
  height: 24,
  marginRight: '-11px',
  marginTop: '1px',
  minWidth: 24,
  paddingBottom: 0,
  width: 24,
});

export const ellipsesActiveStyles = theme => ({
  backgroundColor: theme.palette.secondary.medium,
});

export const extendedLoadingButtonStyles = theme => ({
  ...theme.typography.subtitle2,
  '&:disabled': {
    color: theme.palette.text.secondary,
  },
  color: theme.palette.secondary.main,
});

export const labelsStyles = theme => ({
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
});

export const numbersStyles = theme => ({
  ...theme.typography.h5,
  color: theme.palette.primary.dark,
});

export const titleStyles = {
  flexGrow: 1,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  width: 200,
};
